<script setup lang="ts">
import { ref, computed, watch } from "vue";

const props = defineProps<{
  images: string[];
  selected: number | null;
}>();

const emit = defineEmits(["close"]);

const currentIndex = ref<number>(props.selected ?? 0);

watch(
  () => props.selected,
  (val) => {
    if (val !== null) {
      currentIndex.value = val;
    }
  }
);

const currentImage = computed(() => props.images[currentIndex.value] ?? null);

function close() {
  emit("close");
}

function prev() {
  if (currentIndex.value > 0) {
    currentIndex.value--;
  }
}

function next() {
  if (currentIndex.value < props.images.length - 1) {
    currentIndex.value++;
  }
}
</script>

<template>
  <div class="image-viewer">
    <button @click="close" class="close-btn">✕</button>

    <button v-if="currentIndex > 0" @click="prev" class="prev-btn">‹</button>

    <img :src="currentImage" alt="Imagem" />

    <button
      v-if="currentIndex < images.length - 1"
      @click="next"
      class="next-btn"
    >
      ›
    </button>
  </div>
</template>

<style lang="scss" scoped>
.image-viewer {
  position: fixed;
  inset: 0;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;

  button {
    position: absolute;
    color: white;
    font-weight: bold;
    background: transparent;
    border: 0;
    outline: 0;
    z-index: 51;

    &.close-btn {
      top: 1rem;
      right: 1rem;
      font-size: 1.5rem;

      &:hover {
        color: #f87171; // text-red-500
      }
    }

    &.prev-btn,
    &.next-btn {
      top: 50%;
      font-size: 2.5rem;
      color: #969696;

      &:hover {
        color: white; // text-gray-400
      }
    }

    &.prev-btn {
      left: 1rem;
    }

    &.next-btn {
      right: 1rem;
    }
  }

  img {
    max-height: 90vh;
    max-width: 85vw;
    border-radius: 0.5rem;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
  }
}
</style>
